export default function (workstation, currentPath, companyId) {
  if (workstation) {
    const services = workstation.workstation_services;
    const service = services?.length > 0 ? services[0] : null;
    const type = workstation.workstation_type?.type_name;

    const hasChangeOptionPrintTags =
      type === "traceability" && currentPath === "menu-print-tags";

    const hasChangeOptionSelectedParts =
      type === "traceability" && currentPath === "select-parts";

    if (hasChangeOptionPrintTags && service?.includes("boarding_outgoing")) {
      return "dashboard-tracking";
    }

    if (hasChangeOptionSelectedParts) {
      return "select-parts-tracking";
    }

    return currentPath;
  }

  return currentPath;
}
